import reduceReducers from 'reduce-reducers';

import resourceSearchText from './resourceSearchText';
import resources from './resources';
import results from './results';
import tags from './tags';
import tagSearchText from './tagSearchText';
import view from './view';
import resourceEditor from './resourceEditor';
import tagEditor from './tagEditor';
import groupEditor from './groupEditor';
import tagGroups from './tagGroups';
import queries from './queries';
import sortBy from './sortBy';
import suggestions from './suggestions';

const hubConsole = reduceReducers(
  tags,
  tagGroups,
  resources,
  tagSearchText,
  queries,
  results,
  suggestions,
  resourceSearchText,
  view,
  resourceEditor,
  tagEditor,
  groupEditor,
  sortBy,
);

export default hubConsole;



// WEBPACK FOOTER //
// ./src/reducers/index.js